import { useContext, useEffect } from 'react'
import { updateOLObjectEventListeners } from '../Util';
import { MapContext } from './Map';

export default (props) => {

    const map = useContext(MapContext)

    useEffect(() => {
        if (map) {
            updateOLObjectEventListeners(null, props, map)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [map])

    return null
}